import React from 'react';
import { labelify } from '../../utils/format';

const STATUS_MAP = {
  posted: 'green',
  approved: 'blue',
  draft: 'yellow',
  void: 'red',
  voided: 'red',
  open: 'blue',
  used: 'green',
  paid: 'green',
  pending: 'yellow',
  overdue: 'red',
  active: 'green',
  inactive: 'gray',
  present: 'green',
  late: 'yellow',
  absent: 'red',
  leave: 'purple',
  half_day: 'cyan',
  off: 'gray',
  operator: 'blue',
  helper: 'green',
  staff: 'purple',
  customer: 'blue',
  supplier: 'orange',
  both: 'purple',
  cash: 'green',
  bank: 'blue',
  IN: 'green',
  OUT: 'red',
  general_voucher: 'indigo',
  bank_payment: 'red',
  bank_receipt: 'green',
  cash_payment: 'orange',
  cash_receipt: 'cyan',
  credit: 'purple',
  tax_free: 'cyan',
  sale: 'green',
};

export default function StatusBadge({ status, label }) {
  const color = STATUS_MAP[String(status || '').toLowerCase()] || 'gray';
  return (
    <span className={`badge badge-${color}`}>
      <span className="badge-dot" />
      {label || labelify(status)}
    </span>
  );
}